import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { X } from "lucide-react";

interface ColumnSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function ColumnSearchInput({
  value,
  onChange,
  placeholder = "Search columns",
}: ColumnSearchInputProps) {
  return (
    <div className="flex flex-row items-center gap-1 h-5 ">
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(event) => {
          event.stopPropagation();
          event.preventDefault();
          onChange(event.target.value);
        }}
        className="flex items-center gap-1 w-full h-5"
      />
      {value.length > 0 && (
        <div className="w-fit">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onChange("")}
            className="size-8 "
          >
            <X className="size-" />
          </Button>
        </div>
      )}
    </div>
  );
}
